module.exports = "/images/filter.svg";